import WebStorage from "@adapters/infrastructures/WebStorage";
import Stream from "@adapters/infrastructures/WebSocket";
import socketConfig from "../config/socketConfig";
import CookieStorage from "@adapters/infrastructures/CookieStorage";
export default () => {
    return {
        localStorage: new WebStorage(window.localStorage),
        cookieStorage: new CookieStorage(document.cookie),
        sessionStorage: new WebStorage(window.sessionStorage),
        stream: new Stream(socketConfig.socketURL, socketConfig.port),
    };
};
